import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";

const AdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (!user || user.role !== "admin") {
    // Se non admin, reindirizza alla home o login
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
};

export default AdminRoute;
